import { isNumber, isFinite } from "lodash";

const defaultOption = { maximumFractionDigits: 2 };

export const setDefaultDecimalPlaces = (decimalplaces) => {
  if (!isFinite(decimalplaces)) {
    return;
  }

  defaultOption.maximumFractionDigits = decimalplaces;
};

const getOption = (decimalplaces) => {
  if (!isFinite(decimalplaces)) {
    return defaultOption;
  }

  return { maximumFractionDigits: decimalplaces };
};

/**
 * @param {number | null | undefined} value
 * @param {{ decimalplaces?: number, defaultedValue?: unknown }} [options]
 */
export const numberToLocaleString = (
  value,
  { decimalplaces, defaultedValue = null } = {}
) => {
  const lang = navigator.language || "en-AU";

  return isNumber(value)
    ? value.toLocaleString(lang, getOption(decimalplaces))
    : defaultedValue;
};
